angular.module('rjmNg.directives').directive "segmentConnectionEditor", [
  "$url"
  (
    $url
  ) ->
    restrict: "E"
    templateUrl: "connectionEditors/segment.html"
    replace: false
    scope: {}
    controllerAs: "view"
    controller: [
      "$q"
      "$routeParams"
      "app"
      "dataImportUrl"
      "webhookUrl"
      "$clientAppUrl"
      "notification"
      "InputConnections"
      "$window"
      "Webhooks"
      "ImportTokens"
      "ConnectionMeta"
      "ImportApi"
      (
        $q
        $routeParams
        app
        dataImportUrl
        webhookUrl
        $clientAppUrl
        notification
        InputConnections
        $window
        Webhooks
        ImportTokens
        ConnectionMeta
        ImportApi
      ) ->
        view = @
        view.connectionsPageUrl = $clientAppUrl('/settings/connection/')
        view.webhookBaseUrl = webhookUrl
        view.data =
          id: null
          properties:
            paws_url: ""
            paws_version: 2
          credentials:
            paws_key: ""
          type: "segment_webhooks"

        view.clientId = app.getClientId()
        segmentSettings = {}
        view.saving = false
        InputConnectionsInstance = InputConnections(view.clientId)
        ConnectionMetaInstance = ConnectionMeta(view.clientId)

        # get existing connection if id is supplied
        if $routeParams.connectionId
          view.saving = true
          ConnectionMetaInstance.get($routeParams.connectionId).then((result) ->
            # set initial values
            view.saving = false
            view.csConnectionId = result.conn_service_id
            view.data.id = result.id
            view.data.name = result.meta.name
            view.data.credentials.importToken = result.meta.connection.segment_webhooks.importToken
            view.webhookUrl = view.webhookBaseUrl + '/' +
              "clients/#{view.clientId}/" +
              "connections/#{view.csConnectionId}/" +
              "objects/" +
              "#{view.data.credentials.importToken}"
          )

        view.connectionId = if $routeParams.connectionId then $routeParams.connectionId else null
        view.baseUrl = $url('')
        view.notification = ''
        view.loader = $url("/images/loadingIndicator-small.gif")

        # sets up many deferred objects to chain
        # existing Connections (signified by the existence of routeParams.connectionId)
        # will only be edited / saved, otherwise it will be created
        view.createNewPawsAndSegmentConnection = () ->
          view.saving = true
          pawsDeferred = $q.defer()
          webhookDeferred = $q.defer()
          segmentConnectionDeferred = $q.defer()
          tokenDeferred  = $q.defer()
          view.paws = pawsDeferred.promise
          view.webhook = webhookDeferred.promise
          view.segmentConnection = segmentConnectionDeferred.promise
          view.importToken = tokenDeferred.promise

          # connection already exists, only edit
          if $routeParams.connectionId
            connection = {id: view.csConnectionId, meta_id: view.data.id, name: view.data.name, type: view.data.type}

            InputConnectionsInstance.save(connection).then(
              (result) ->
                view.saving = false
                _segmentConnectionSaveSuccess()
              ,
              (error) ->
                view.saving = false
                _newSegmentConnectionError()
            )
          # new connection create all required assets
          else
            $q.all([
              _createImportToken(tokenDeferred),
              _createPawsConnection(pawsDeferred),
              _createNewSegmentConnection(segmentConnectionDeferred),
              _createSegmentWebHook(webhookDeferred)])
            .then _newSegmentConnectionSuccess, _newSegmentConnectionError

        # create a client level import scoped token for this connection
        _createImportToken = (deferred) ->
          ImportTokens(view.clientId).create()
          .then (result) ->
            deferred.resolve result

        # creates a new paws connection if using version 2 (aka CloudBI Client)
        # or returns an empty credentials Map if using version 3 (Stitch)
        # returns existing paws connection if editing an existing connection
        _createPawsConnection = (deferred) ->
          view.importToken.then((token) ->
            view.importToken = token
            pawsVersion = view.data.properties.paws_version
            view.data.properties.paws_version = String(pawsVersion) # paws version must be a string
            view.data.credentials.importToken = view.importToken.access_token

            # this (currently) creates a connections.connections entry
            view.data.properties.paws_url = dataImportUrl.replace /v1\//, ''
            ImportApi(view.clientId).create
              name: view.data.name
              type: view.data.type
            .then (result) ->
              deferred.resolve result
          )

        # creates a new record with the Connections and Webhooks service
        _createNewSegmentConnection = (deferred) ->
          view.paws.then((paws) ->
            view.paws = paws
            view.data.credentials.paws_key = paws.meta.connection.key
            view.data.id = paws.id
            view.data.properties.status = '1'
            view.redirectUrl = "#{view.connectionsPageUrl}segment/#{view.paws.id}?success=true"
            pawsVersion = view.data.properties.paws_version # this has been Stringified

            # we already called out to /importapi/ which creates a connection with the ConnectionService
            # so we save the existing connection instead of creating a new one
            ConnectionMetaInstance.get(view.paws.id).then((result) ->
              view.csConnectionId = result.conn_service_id
              connection = angular.extend({}, view.data, {id: view.csConnectionId, meta_id: view.data.id})
              InputConnectionsInstance.save(connection).then((result) ->
                deferred.resolve result
              )
            )
          )

        _createSegmentWebHook = (deferred) ->
          view.segmentConnection.then((segmentConnection) ->
            segmentSettings.endpoint =
              view.webhookBaseUrl + '/' +
              "clients/#{view.clientId}/" +
              "connections/#{segmentConnection.id}/" +
              "objects/" +
              "#{view.importToken.access_token}"

            _createSegmentButton()
            view.segmentRedirect = view.segmentButton.element.href

            Webhooks(view.clientId).create(
              table_name: 'objects'
              type: 'segment'
              is_deleted: 0
              connection_id: segmentConnection.id
              client_id: view.clientId
              product: "dashboard"
            ).then((result) ->
              deferred.resolve result
            )
          )

        # redirects to segment.com to approve the integration
        _newSegmentConnectionSuccess = (response) ->
          $window.location.href = view.segmentRedirect

        _segmentConnectionSaveSuccess = (response) ->
          notification.success("Segment Connection Success", "Successfully saved Segment Connection", "segment-connection", null, 5)

        # error has occurred on our end
        _newSegmentConnectionError = (error) ->
          notification.error("Segment Connection Error", "There was an error creating the Segment Connection. Please contact Adobe Commerce Intelligence support.", "segment-connection", null, 5)

        # creates a segment button so we can steal the url to redirect to from it
        # this will be hidden
        _createSegmentButton = () ->
          view.segmentButton = new $window.segment.EnableButton(
              element: '.segmentButton'
              settings: segmentSettings
              size: 'large'
              redirectUrl: view.redirectUrl # redirect back to this connection
              integration: 'stitch'
          )

        # back to connections list
        view.back = ->
          $window.location.href = view.connectionsPageUrl

        view
    ]

]
